import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { ControlSheetAnnotationDTO } from '@/types/controlsheet'

interface IPatchTimingAnnotationRequest {
    annotationId: string
    startTime?: string
    departureTime?: string
    serviceNotOperated?: boolean
}

interface IPatchMealReliefAnnotationRequest {
    annotationId: string
    startTime?: string
    departureTime?: string
}

export const usePatchAnnotation = () => {
    const patchTimingAnnotationMutation = useAppMutation<
        ControlSheetAnnotationDTO,
        Error,
        IPatchTimingAnnotationRequest
    >({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/${data.annotationId}`,
                method: 'PATCH',
                data: {
                    startTime: data.startTime,
                    departureTime: data.departureTime,
                    serviceNotOperated: data.serviceNotOperated,
                },
            }),
        alertOnError: true,
    })

    const handlePatchTimingAnnotationAsync = (
        annotationId: string,
        startTime?: string,
        departureTime?: string,
        serviceNotOperated?: boolean
    ) =>
        patchTimingAnnotationMutation.mutateAsync({
            annotationId,
            startTime,
            departureTime,
            serviceNotOperated,
        })

    const patchMealReliefAnnotationMutation = useAppMutation<
        ControlSheetAnnotationDTO,
        Error,
        IPatchMealReliefAnnotationRequest
    >({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/${data.annotationId}`,
                method: 'PATCH',
                data: {
                    startTime: data.startTime,
                    departureTime: data.departureTime,
                },
            }),
    })

    const handlePatchMealReliefAnnotationAsync = (annotationId: string, startTime?: string, departureTime?: string) =>
        patchMealReliefAnnotationMutation.mutateAsync({
            annotationId,
            startTime,
            departureTime,
        })

    return {
        handlePatchTimingAnnotationAsync: handlePatchTimingAnnotationAsync,
        handlePatchMealReliefAnnotationAsync: handlePatchMealReliefAnnotationAsync,
        isPending: patchTimingAnnotationMutation.isPending,
        data: patchTimingAnnotationMutation.data,
        error: patchTimingAnnotationMutation.error,
    }
}
